import { CodeBlock as CodeBlock_phosphor } from './CodeBlockIcon.phosphor';

const IconRenderer = () => {
  switch (process.env.NEXT_PUBLIC_ICON_SYSTEM) {
    default:
      return CodeBlock_phosphor;
  }
};

export const CodeBlockIcon = IconRenderer();
